(function () {
  /**
   * FLORENTIA – newsletter-effekt.js
   * Newsletter-Formular: Beim Absenden fliegen Blüten aus dem Button (window.florentiaBlueten aus
   * assets/blueten-effekt.js, 55 Stück), der Button zeigt «Wird gesendet …». Nach kurzer Verzögerung
   * wird das Formular normal an Shopify abgeschickt; die Bestätigung kommt mit dem Seiten-Reload.
   * Ohne JavaScript oder bei «Bewegung reduzieren» läuft das Formular wie bisher, nur ohne Partikel.
   * Wird nur von sections/newsletter.liquid geladen.
   */
  'use strict';

  if (window.__florentiaNewsletterEffekt) return;
  window.__florentiaNewsletterEffekt = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SUBMIT_DELAY = REDUCE ? 0 : 700; // ms, bis das Formular wirklich abgeschickt wird
  var BLUETEN = 55;

  // ── Abschicken mit Shopify-Spamschutz ──
  // Ein programmatisches form.submit() überspringt das Submit-Ereignis, an dem hCaptcha sein
  // Token anhängt → Shopify leitet auf /challenge um. Shopify.captcha.protect verdrahtet das
  // Formular und ruft danach den Callback auf (Weg laut Shopify-Doku «CAPTCHA»).
  function sendForm(form) {
    var captcha = window.Shopify && window.Shopify.captcha;
    if (captcha && typeof captcha.protect === 'function') {
      captcha.protect(form, function () { form.submit(); });
    } else if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(); // löst das Submit-Ereignis aus, unser Handler lässt es durch
    } else {
      form.submit();
    }
  }

  // ── Formulare verdrahten ──
  function init() {
    var wrappers = document.querySelectorAll('.newsletter-form');
    for (var i = 0; i < wrappers.length; i++) {
      var form = wrappers[i].closest('form');
      if (!form || form.__nlBound) continue;
      form.__nlBound = true;
      bind(form);
    }
  }

  function bind(form) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    var originalLabel = btn.textContent;
    var sendingLabel = btn.getAttribute('data-sending-label') || originalLabel;

    form.addEventListener('submit', function (e) {
      if (form.__nlSubmitting) return;           // zweiter Durchlauf: normal abschicken
      if (!form.checkValidity()) return;         // Browser zeigt die Pflichtfeld-Meldung
      e.preventDefault();
      form.__nlSubmitting = true;

      if (window.florentiaBlueten) window.florentiaBlueten(btn.getBoundingClientRect(), BLUETEN);

      btn.style.minWidth = btn.offsetWidth + 'px'; // Breite halten, damit nichts springt
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = sendingLabel;

      setTimeout(function () { sendForm(form); }, SUBMIT_DELAY);
    });

    // Zurück-Navigation aus dem Browser-Cache: Button zurücksetzen
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      form.__nlSubmitting = false;
      btn.removeAttribute('aria-busy');
      btn.style.minWidth = '';
      btn.textContent = originalLabel;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
